module.exports = __webpack_public_path__ + "img/logo.d2092b83.png";